export default "__VITE_ASSET__BzMmcecz__"